import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewRelatedRoomTags from './viewRelatedRoomTags';

export default {
  title: 'Vision Pro Images',
  attributeName: 'sportsRoom',
  fields: [
     {
      attributeName: 'heroImageVO',
      type: FormInputTypes.DOWNLOADABLE,
      allowedSizes: [
        { width: 1696, height: 612 },
        { width: 848, height: 306 }
      ],
      
      hasSelect:false,
      label: 'Hero Banner - 1696x612 or 848x306',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
    },
    {
      attributeName: 'spacethumbnailVO',
      type: FormInputTypes.DOWNLOADABLE,
      // aspectRatio: '159:332',
      allowedSizes: [
        { width: 320, height: 320 },
        { width: 160, height: 160 },
      ],
      hasSelect:false,
      label: 'Space Thumbnail - 320x320 or 160x160',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
    },
     {
      attributeName: 'spaceHeaderVO',
      type: FormInputTypes.DOWNLOADABLE,
      allowedSizes: [
        { width: 1696, height: 612 },
        { width: 928, height: 334 }
      ],
      
      hasSelect:false,
      label: 'Top Banner 1696x612 or 928x334',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
    },
  ],
};
